import { motion } from "framer-motion";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      className="relative py-28 md:py-40 px-6 md:px-12 lg:px-20 bg-cream"
      data-testid="contact-section"
    >
      <div className="max-w-[1400px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-[1px] bg-terracotta" />
            <span className="text-xs uppercase tracking-[0.3em] text-ink/60">
              Venir nous voir
            </span>
          </div>
          <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light leading-[0.95] max-w-3xl">
            Poussez la porte, <br />
            <span className="italic-serif text-terracotta">
              écoutez la matière.
            </span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="space-y-1">
            {[
              {
                icon: MapPin,
                label: "Adresse",
                main: "17 rue de Pierrefonds",
                sub: "60200 Compiègne",
                href: "https://maps.google.com/?q=17+rue+de+Pierrefonds+60200+Compiègne",
                test: "contact-address",
              },
              {
                icon: Phone,
                label: "Téléphone",
                main: "07 67 39 66 99",
                sub: "Accueil direct",
                href: "tel:+33767396699",
                test: "contact-phone",
              },
              {
                icon: Mail,
                label: "Email",
                main: "contact@soundyoga.fr",
                sub: "Réponse sous 24h",
                href: "mailto:contact@soundyoga.fr",
                test: "contact-email",
              },
              {
                icon: Clock,
                label: "Retrait en boutique",
                main: "Sur rendez-vous",
                sub: "Venez essayer vos instruments favoris",
                href: "tel:+33767396699",
                test: "contact-pickup",
              },
            ].map((item, i) => {
              const Icon = item.icon;
              return (
                <motion.a
                  key={item.label}
                  href={item.href}
                  target={item.href.startsWith("http") ? "_blank" : undefined}
                  rel="noreferrer"
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 0.7,
                    delay: i * 0.1,
                    ease: [0.16, 1, 0.3, 1],
                  }}
                  className="group flex items-start gap-6 py-7 border-t border-ink/10 last:border-b hover:bg-sand/50 transition-colors px-2 md:px-4 -mx-2 md:-mx-4 rounded-sm"
                  data-testid={item.test}
                >
                  <div className="w-12 h-12 rounded-full bg-sand flex items-center justify-center group-hover:bg-terracotta transition-colors shrink-0">
                    <Icon
                      size={18}
                      className="text-terracotta group-hover:text-cream transition-colors"
                    />
                  </div>
                  <div className="flex-1">
                    <div className="text-xs uppercase tracking-[0.2em] text-ink/50 mb-1">
                      {item.label}
                    </div>
                    <div className="font-serif text-xl md:text-2xl text-ink">
                      {item.main}
                    </div>
                    <div className="text-sm text-ink/60 mt-1">{item.sub}</div>
                  </div>
                </motion.a>
              );
            })}
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
            className="relative rounded-3xl overflow-hidden bg-sand aspect-[4/5] md:aspect-auto md:h-full md:min-h-[560px]"
          >
            <iframe
              title="Boutique Yogi Market Compiègne"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2596.1!2d2.8261!3d49.4179!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s17%20rue%20de%20Pierrefonds%2060200%20Compi%C3%A8gne!5e0!3m2!1sfr!2sfr"
              className="absolute inset-0 w-full h-full grayscale hover:grayscale-0 transition-all duration-700"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="map-iframe"
            />
            <div className="absolute top-6 left-6 bg-cream/90 backdrop-blur-md px-4 py-2 rounded-full">
              <span className="text-[10px] uppercase tracking-[0.2em] text-ink">
                📍 Compiègne, Oise
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
